<template>
  <div class="contenedor-selector selector-municipal">
    <input class="selector" type="text" 
      :placeholder="placeholder" 
      v-on:click="abrirLista=true"
      v-model="buscadorTexto" />

    <div class="contenedor-lista lista-municipal" 
      v-bind:class="{'abrir-lista': abrirLista}">
      <div class="contenedor-lista-opciones">
        <button class="btn-limpiar-lista"
          v-bind:class="{'disabled': seleccion.length==0}"
          v-on:click="limpiarSeleccion()"
        >Limpiar selección</button>

        <button class="btn-cerrar-lista"
          v-on:click="abrirLista=false"
        >&times;</button>
      </div>

      <div class="item" v-for="municipio in filtroMunicipios"
        :key="municipio.cvegeomun">
        <input type="checkbox" v-bind:id="municipio.cvegeomun" 
          v-bind:value="municipio.cvegeomun"
          v-model="seleccion"
          @change="cambiarSeleccion()">
        <label v-bind:for="municipio.cvegeomun">{{ municipio.nom_mun }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import VihMunicipios from '@/components/mapa/capas/VihMunicipios.js';

const placeholderInicial = 'Municipio';

export default {
  data() {
    return {
      placeholder: placeholderInicial,
      abrirLista: false,
      estados: [],
      municipios: [],
      seleccion: [],
      buscadorTexto: '',
    };
  },
  mounted() {
    this.cargarListaMunicipal();
  },
  methods: {
    ...mapMutations(['cambiarMapaModo','cambiarMapaCvesMun','reiniciarMapaCvesMun',]),
    cargarListaMunicipal() {
      const vihMunicipios = new VihMunicipios();
      vihMunicipios.wfs.columnas = 'nom_mun';
      vihMunicipios.wfs.orden = 'nom_mun';

      if (this.estados.length > 0) {
        vihMunicipios.wfs.filtro = this.estados
          .map(edo => `strSubstring(cvegeomun,0,2)='${edo}'`).join(' or ');
        console.log(vihMunicipios.wfs.url);
      }

      vihMunicipios.wfs.cargarPropiedades.then(data => {
        this.municipios = data;
      });
    },
    limpiarSeleccion() {
      this.seleccion = [];
      this.cambiarMapaModo('estatal');
      this.reiniciarMapaCvesMun();
    },
    cambiarSeleccion() {
      if (this.seleccion.length == 0) {
        this.limpiarSeleccion();
      } else {
        this.cambiarMapaModo('municipal');
        this.cambiarMapaCvesMun(this.seleccion);
      }
    },
    actualizarPlaceholder() {
      if (this.seleccion.length == 0){
        this.placeholder = placeholderInicial;
      } else if (this.seleccion.length == 1) {
        this.placeholder = this.municipios
          .find(mun => mun.cvegeomun===this.seleccion[0]).nom_mun;
      } else {
        this.placeholder = 'Selección multiple';
      }
    },
  },
  computed: {
    ...mapGetters(['actualMapaModoYCves',]),
    filtroMunicipios() {
      return this.buscadorTexto.length > 2
        ? this.municipios.filter(mun => mun.nom_mun.toLowerCase()
          .includes(this.buscadorTexto.toLowerCase()))
        : this.municipios;
    }
  },
  watch: {
    actualMapaModoYCves(actual) {
      if (actual.modo === 'inicial') {
        this.seleccion = [];
      }
      if (actual.modo === 'estatal') {
        this.seleccion = [];
      }
      if (actual.modo === 'municipal') {
        if (JSON.stringify([...actual.cvesEdo].sort()) !==
          JSON.stringify(this.estados.sort())) {
          this.estados = actual.cvesEdo;
          this.cargarListaMunicipal();
        }
        this.seleccion = actual.cvesMun;
      }
      this.actualizarPlaceholder();
    },
  }
}
</script>

<style lang="scss">
.selector-municipal {
  .selector {
    cursor: text;
  }
}
</style>